// Режим «медленно» для озвучки в уроках и повторении (очередь идей 2026-09-17, п. 1).
// Одна настройка на устройство (localStorage), без сервера: включил черепашку —
// все кнопки «Прослушать» в уроке играют mp3 на SLOW_RATE (lib/speak.ts) с
// сохранением высоты голоса; запасной голос браузера — с той же скоростью.
// В чате и тренажёре у SpeakButtons своя отдельная кнопка ×0.75 — там ничего не меняем.
import { useSyncExternalStore } from 'react'

const KEY = 'tk-slow-audio'
const listeners = new Set<() => void>()

function read(): boolean {
  try {
    return window.localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function getSlowAudio(): boolean {
  if (typeof window === 'undefined') return false
  return read()
}

export function setSlowAudio(on: boolean) {
  try {
    if (on) window.localStorage.setItem(KEY, '1')
    else window.localStorage.removeItem(KEY)
  } catch {}
  listeners.forEach((cb) => cb())
}

function subscribe(cb: () => void) {
  listeners.add(cb)
  window.addEventListener('storage', cb)
  return () => {
    listeners.delete(cb)
    window.removeEventListener('storage', cb)
  }
}

// На сервере и при гидратации — false, затем клиент перечитывает (без расхождения разметки).
export function useSlowAudio(): boolean {
  return useSyncExternalStore(subscribe, read, () => false)
}
